import React, { useState } from 'react';
import DatePicker from 'react-date-picker';
import Select from 'react-select';
import { ReactComponent as CalendarIcon } from '../../assets/icons/calendar.svg';
import { ReactComponent as ClearIcon } from '../../assets/icons/close.svg';
import { EnergyPackageStatistic } from 'components/EnergyPackages/models';
import { Button, Spinner } from 'react-bootstrap';

interface EnergyAgreementsSearchBarProps {
    onSearchChange: (searchQuery: string) => void;
    onPeriodChange: (periodStart?: string, periodEnd?: string) => void;
    onStatusChange: (isActive?: boolean) => void;
    statistics?: EnergyPackageStatistic[];
    getReport: () => void;
    isExporting: boolean;
}

const statuses = [
    { value: true, label: "Aktiivne" },
    { value: false, label: "Lõppenud" }
];

const selectStyle = {
    indicatorSeparator: () => (
        {
            backgroundColor: 'red',
            width: '50px',
        }
    ),
};

export function EnergyAgreementsSearchBar(props: EnergyAgreementsSearchBarProps){
    const [search, setSearch] = useState("");
    const [isActive, setIsActive] = useState<boolean | undefined>(true);
    const [periodStart, setPeriodStart] = useState<string>();
    const [periodEnd, setPeriodEnd] = useState<string>();

    const onInputChange = (inputEvent: any) => {
        setSearch(inputEvent.target.value);
        props.onSearchChange(inputEvent.target.value);
    };

    const onSelectChange = (inputEvent: any) => {
        setIsActive(inputEvent?.value);
        props.onStatusChange(inputEvent?.value);
    };

    const onPeriodChange = (periodStart?: string, periodEnd?: string) => {
        setPeriodStart(periodStart);
        setPeriodEnd(periodEnd);
        props.onPeriodChange(periodStart, periodEnd);
    } 

    return (
        <div className="bar-position">
            <h2 className='text-light'>
                Energialepingud
            </h2>
            <div className="card mb-5 shadow">
                <div className="card-body">
                <div className="d-flex flex-column flex-lg-row justify-content-between align-items-xl-center">
                        <div className='d-flex'>
                            <div className='d-flex flex-column flex-xl-row'>
                                <input
                                    placeholder="Nimi / Isikukood"
                                    className='search-bar__input p-2 mb-2 mb-xl-0'
                                    onChange={onInputChange}
                                    value={search}
                                />     
                                <Select
                                    style={selectStyle}
                                    className='mw-160-px mr-2 customer-status__select'
                                    value={statuses.find(s => s.value === isActive) || null}
                                    onChange={onSelectChange}
                                    options={statuses}
                                    isClearable
                                    placeholder='Vali staatus'
                                />
                            </div>
                            <div className='d-flex flex-column flex-xl-row'>
                                <DatePicker
                                    className="mr-2 mb-2 mb-xl-0"
                                    value={periodStart ? new Date(periodStart) : null}
                                    locale='et'
                                    clearIcon={<ClearIcon />}
                                    calendarIcon={<CalendarIcon />}
                                    format='dd.MM.yyyy'
                                    onChange={(event: any) => {
                                        if(!event){
                                            onPeriodChange(undefined, periodEnd)
                                            return;
                                        }

                                        onPeriodChange(new Date(event).toString(), periodEnd)
                                    }}
                                />
                                <DatePicker
                                    value={periodEnd ? new Date(periodEnd) : null}
                                    locale='et'
                                    clearIcon={<ClearIcon />}
                                    calendarIcon={<CalendarIcon />}
                                    format='dd.MM.yyyy'
                                    onChange={(event: any) => {
                                        if(!event){
                                            onPeriodChange(periodStart, undefined)
                                            return;
                                        }

                                        onPeriodChange(periodStart, new Date(event).toString())
                                    }}
                                />
                            </div>
                            <div>
                                <Button 
                                    className="ml-2 d-flex justify-content-center align-items-center"
                                    onClick={() => props.getReport()}
                                    variant={"primary"}
                                    style={{
                                     width: "80px"
                                    }}
                                >
                                     {
                                        props.isExporting ? (
                                            <>
                                                <Spinner size={"sm"} animation={"border"}/>
                                            </>
                                        ) : <span>Eksport</span>
                                    }
                                </Button>
                            </div>
                        </div>
                        <div className='d-flex flex-column mt-2 mt-lg-0'>
                            {
                                props.statistics?.map(statistic => (
                                    <div className='font-weight-bold' key={statistic.name}>{statistic.name} liitunuid - {statistic.activeCount}</div>
                                ))
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}